export const showNotificationType = 'NOTIFICATION_SHOW';
export const clearNotificationType = 'NOTIFICATION_CLEAR';
export const storeNotifKey = 'STORE_NOTIFICATION_KEY';
